/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["អធ្រាត្រ","ថ្ងៃត្រង់","នៅពេល​ព្រឹក","នៅពេលរសៀល","នៅពេល​ល្ងាច","នៅពេល​យប់"],u,u],[["អធ្រាត្រ","ថ្ងៃ​ត្រង់","ព្រឹក","រសៀល","ល្ងាច","យប់"],u,u],["00:00","12:00",["00:00","12:00"],["12:00","18:00"],["18:00","21:00"],["21:00","24:00"]]];
